import { Locale } from "@/i18n/types";

export const formatCurrency = (props: {
  value: number;
  currency: string;
  lang?: string;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
  currencySign?: Intl.NumberFormatOptions["currencySign"];
}) => {
  const {
    value,
    currency,
    lang = Locale.EN,
    maximumFractionDigits = 0,
    minimumFractionDigits = 0,
    currencySign = "accounting",
  } = props;
  return Intl.NumberFormat(lang, {
    style: "currency",
    currency,
    maximumFractionDigits,
    minimumFractionDigits,
    currencySign,
  }).format(value);
};
